<template>
  <div id="accordion">
    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <div class="m-1 row justify-content-center">
            <b-button
              squared
              class="m-1"
              @click="showConnectFields = !showConnectFields"
              variant="info"
            >
              CONNECTION SETTINGS&nbsp;
              <b-iconstack
                font-scale="1"
                :rotate="!showConnectFields ? '180' : ''"
              >
                <b-icon stacked icon="chevron-down" scale="0.75"></b-icon>
                <b-icon stacked icon="circle"></b-icon>
              </b-iconstack>
            </b-button>
            <b-button
              :disabled="!playbookUriValid || !playbookUriFormatted"
              class="m-1"
              v-show="!SSOLoginOnly"
              squared
              @click="clientBundle.logonData ? pbLogout() : enterKeyHandler()"
            >
              {{ !clientBundle.logonData ? "log on" : "log off" }}
              <b-spinner type="grow" v-if="logonButtonDirty" small></b-spinner>
            </b-button>
            <b-button
              disabled
              squared
              class="m-1"
              variant="success"
              v-show="clientBundle.logonData !== false"
              >Connected
            </b-button>
            <div
              v-if="
                ssoSettings.settings.length > 0 && ssoSettings.config.AuthAppUrl
              "
            >
              <b-button
                v-for="sso in ssoSettings.settings"
                v-bind:key="sso.ID"
                squared
                class="sso-login-button secondary m-1"
                :style="`display: block;
                  background-size: 20px 20px;
                  background-repeat: no-repeat;
                  background-position: 5px 5px;
                  padding-left: 20px;
                  width: auto;
                  background-image: url(&quot;${sso.Icon}&quot;);`"
                @click="!clientBundle.logonData ? onSSOClick(sso) : pbLogout()"
              >
                &nbsp;&nbsp;{{
                  !clientBundle.logonData ? sso.Description : "log off"
                }}
              </b-button>
            </div>
          </div>
        </b-card-header>
        <b-collapse
          id="api-logon-page"
          :visible="!clientBundle.logonData"
          v-model="showConnectFields"
          role="tabpanel"
        >
          <b-alert
            :show="showConnectError === true"
            variant="warning"
            dismissible
          >
            Unable to connect: check
            {{
              [
                apiInfoTest.user === false ? " username" : "",
                apiInfoTest.password === false ? " password" : "",
                apiInfoTest.serverResponse === false ||
                !apiInfoTest.serverUrl === false
                  ? " url"
                  : "",
              ]
                .filter((y) => y !== "")
                .join(", ")
            }}
          </b-alert>
          <b-alert v-model="showDisconnectAlert" variant="danger" dismissible>
            Disconnected from server since
            {{ new Date(lastPingTime).toLocaleString() }}
          </b-alert>
          <b-card-body>
            <form action="javascript:void(0);">
              <b-input-group prepend="Username" class="mt-3">
                <b-form-input
                  trim
                  :disabled="clientBundle.logonData != false"
                  :class="`${
                    vmAuth.userId === '' || apiInfoTest.user === false
                      ? 'invalidAuth'
                      : ''
                  }`"
                  id="api-client-username"
                  v-model="vmAuth.userId"
                  type="text"
                  placeholder="username"
                  autocomplete="on"
                  :formatter="
                    (value) => {
                      return value.toUpperCase();
                    }
                  "
                ></b-form-input>
                <b-popover
                  variant="warning"
                  v-if="apiInfoTest.user === false"
                  target="api-client-username"
                  triggers="hover"
                  placement="top"
                >
                  <template #title>Invalid username</template>
                  Couldn't authenticate <b>{{ vmAuth.userId }} </b> with the api
                  webservice!
                </b-popover>
              </b-input-group>

              <b-input-group prepend="Password" class="mt-3">
                <b-form-input
                  v-on:keyup.enter="enterKeyHandler()"
                  trim
                  :disabled="clientBundle.logonData != false"
                  :class="`${
                    vmAuth.password === '' || apiInfoTest.password === 'false'
                      ? 'invalidAuth'
                      : ''
                  }`"
                  id="api-client-password"
                  v-model="vmAuth.password"
                  type="password"
                  autocomplete="on"
                ></b-form-input>
                <b-popover
                  variant="warning"
                  v-if="apiInfoTest.password === false"
                  target="api-client-password"
                  triggers="hover"
                  placement="bottom"
                >
                  <template #title>Bad password</template>
                  The password you entered for user
                  <b>{{ vmAuth.userId }} </b> was rejected by the api
                  webservice! check your password and try again.
                </b-popover>
              </b-input-group>

              <b-input-group prepend="URL" class="mt-3 mb-3">
                <b-form-input
                  :disabled="clientBundle.logonData != false"
                  v-on:keyup.enter="enterKeyHandler()"
                  @input="urlInputHandler()"
                  @blur="enterKeyHandler()"
                  trim
                  :class="` ${playbookUriValid ? 'validUrl' : ''}`"
                  v-model="vmAuth.playbookUri"
                  type="url"
                  id="api-client-url"
                  debounce="1100"
                  autocomplete="on"
                  :value="queryParams.url"
                  placeholder="http://MYAPISERVER/ or https://MYSERVER.applaybook.com"
                  name="apiurl"
                ></b-form-input>
                <!-- <b-input-group-append>
                <b-button variant="outline-success" @click="enterKeyHandler()"
                  >Check URL</b-button
                >
              </b-input-group-append> -->
              </b-input-group>
            </form>
            <b-popover
              variant="warning"
              v-if="apiInfoTest.serverResponse === false"
              target="api-client-url"
              triggers="hover"
              placement="top"
            >
              <template #title>Bad webservice URL</template>
              {{
                `${
                  playbookUriValid
                    ? "The url appears has a valid format.\r\nBut there was no response from at the address:"
                    : "There's something wrong with the format of the url:"
                }`
              }}
              {{ vmAuth.playbookUri }}.
            </b-popover>
            <b-alert :show="!playbookUriValid" variant="danger"
              >Enter a valid url</b-alert
            >
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>
<script>
import { playbookControl, clearHTMLTags } from "./pbControl";
const ENPSObjectDictionary = {
  0: "Unassigned",
  1: "Wire",
  2: "Rundown",
  3: "Script",
  4: "Audio",
  5: "Video",
  6: "Picture",
  7: "Readin",
  8: "Planning Item",
  9: "Message",
  10: "Grid",
  11: "Contact",
  12: "Planning Grid",
  13: "MOS Object",
  14: "Election",
  15: "MOS Object Reference",
  16: "OPENS",
  138: "Assignment",
  137: "Topic",
};
const timeStr = function (secs = 0) {
  // secs = 1000 * (Number.parseInt(secs) + Number.parseInt(moreSecs));
  // return new Date(1000 * secs).toISOString().substr(11, 8);
  return new Date(1000 * secs).toISOString().substring(11, 19);
};

function localCurrencyFormatter(number) {
  let locale = navigator.languages[0] || navigator.language || "en-US";
  let num = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "USD",
  });
  return num.format(number);
}

export default {
  name: "APIClient",
  props: {
    searchFieldsPayload: Array,
    auth: Object,
  },
  data() {
    return {
      pstGroupFlag: false,
      logonButtonDirty: false,
      showConnectFields: true,
      showDisconnectAlert: false,
      showConnectError: false,
      keepAlivePing: null,
      lastPingTime: "",
      retryCounters: {
        timedPing: 0,
        ping: 0,
        gTables: 0,
        gFields: 0,
        rundown: 0,
        list: 0,
        search: 0,
        testUrl: 0,
      },
      uriTest: { server: null, url: null },
      apiInfoTest: {
        serverResponse: null,
        serverUrl: null,
        server: { server: null, url: null },
        user: null,
        password: null,
      },
      ssoSettings: { settings: [], config: {} },
      vmAuth: {
        userId: "",
        devKey: "e26beff9-09a6-4d29-9a11-6a403d4730b5",
        domainUserId: "",
        password: "",
        domain: "",
        playbookUri: `${window.location.protocol}//${
          window.location.search.substring(1).split("host=")[1] || "CHANGEME"
        }/`,
        playbookUriServiceUrls: [
          localStorage.getItem("playbookUriServiceUrls0"),
          localStorage.getItem("playbookUriServiceUrls1"),
        ].filter((y) => Boolean(y)),
        xToken: "",
        ssoToken: "",
      },
      clientBundle: {
        serverType: null,
        gFields: null,
        gTables: null,
        logonData: false,
        savedSearches: {
          guid: "",
          title: "",
          path: "",
          database: "",
          type: null,
          list: {},
        },
      },
      searchResults: [],
    };
  },
  computed: {
    vmAuthComputed: function () {
      const t = this;
      return {
        ...t.vmAuth,
        playbookUri:
          t.vmAuth.playbookUriServiceUrls[0] || t.playbookUriFormatted,
      };
    },
    SSOLoginOnly: function () {
      const t = this;
      const force =
        t.ssoSettings &&
        t.ssoSettings.config &&
        t.ssoSettings.config.ForceLoginWithSSO
          ? t.ssoSettings.config.ForceLoginWithSSO
          : false;
      return Boolean(JSON.parse(force));
    },
    SSORedirectUrl: function () {
      return window.location.href;
    },
    queryParams: function () {
      const t = this;
      // let params = new URLSearchParams(`${window.location.search.substr(1)}`);
      let params = new URLSearchParams(
        `${window.location.search.replace("?", "")}`
      );
      if (params.get("report")) {
        localStorage.setItem("report", params.get("report"));
      }

      if (params.get("host")) {
        localStorage.setItem(
          "playbookUri",
          `https://${params.get("host")}/nomwebservices3api/api`
        );
        t.vmAuth.playbookUri = `https://${params.get(
          "host"
        )}/nomwebservices3api/api`;
      }
      return {
        reportType: params.get("report"),
        host: params.get("host"),
        url: `https://${params.get("host")}/nomwebservices3api/api`,
      };
    },
    versionType: function () {
      return process.env.NODE_ENV;
    },
    playbookUriFormatted: function () {
      //checks if format is valid for a url
      const t = this;
      // new string var with url
      let testUrl = t.vmAuth.playbookUri + "";
      let forceHttps = testUrl.toLowerCase().indexOf("playbook.com") > -1;

      try {
        //if url is blank or
        if (testUrl === "" || testUrl.toLowerCase().indexOf("changeme") > -1) {
          //ignoring blank or changeme return true
          return true;
        }
        //if testUrl a hostname only, prepend window protocol to hostname
        if (testUrl.indexOf("://") === -1) {
          testUrl = `${forceHttps ? "https:" : window.location.protocol}//${
            new URL("http://" + testUrl).hostname
          }/nomwebservices3api/api/`;
        } else {
          testUrl = `${forceHttps ? "https:" : new URL(testUrl).protocol}//${
            new URL(testUrl).hostname
          }/nomwebservices3api/api/`;
        }
        // test url is valid

        const url = new URL(testUrl);
        return url.href;
      } catch (e) {
        return false;
      }
    },
    playbookUriValid: function () {
      //checks if format is valid for a url
      const t = this;
      try {
        // if (t.playbookUriFormatted) {
        const url = new URL(t.playbookUriFormatted);
        return url.protocol === "http:" || url.protocol === "https:";
        // }
      } catch (e) {
        return false;
      }
    },
  },
  mounted: function () {
    const t = this;
    //check for SSO info in QS
    const matchSSOToken = /idToken=(.*)/;
    const foundSSOToken = window.location.href.match(matchSSOToken);

    if (foundSSOToken) {
      //SSO token from URL this is an SSO response
      localStorage.setItem("idToken", foundSSOToken[1]);
      t.vmAuth.ssoToken = foundSSOToken;
      t.vmAuth.playbookUri = localStorage.getItem("playbookUri");
      // t.vmAuth.playbookUriServiceUrls=[localStorage.getItem("playbookUriServiceUrls0"), localStorage.getItem("playbookUriServiceUrls1")].filter(y=>Boolean(y));

      t.pbSSOLogon();
    } else if (
      //previous token exists attempt to reuse
      localStorage.getItem("idToken") &&
      localStorage.getItem("playbookUri")
    ) {
      t.vmAuth.playbookUri = localStorage.getItem("playbookUri");
      t.vmAuth.ssoToken = ["", localStorage.getItem("idToken")];
      t.pbSSOLogon();
    } else if (!t.queryParams.host && localStorage.getItem("playbookUri")) {
      // no SSO,  no host url in QS but one found in LS
      t.vmAuth.playbookUri = localStorage.getItem("playbookUri");
    } else {
      //try to get local storage info and reuse
      t.getLocal(function (a) {
        if (a.xToken) {
          try {
            t.pbPing((x) => {
              if (x && t.vmAuth.userId && t.vmAuth.password) {
                t.pbLogon();
              }
            });
          } catch (e) {
            console.log(e);
          }
        }
      });
    }
  },
  watch: {
    clientBundle: {
      deep: true,
      handler: function () {
        const t = this;
        if (t.clientBundle.gTables) {
          t.clientBundle.serverType = t.guessServerType();
        }
        t.updateParent("auth");

        //add playbook groups to PSTgroup list
        if (
          !t.pstGroupFlag &&
          t.clientBundle.gTables &&
          t.clientBundle.gTables._Groups &&
          t.clientBundle.gFields &&
          t.clientBundle.gFields.complete &&
          t.clientBundle.gFields.complete.filter(
            (y) => y.ID.toUpperCase() === "PSTGROUP"
          ).length > 0
        ) {
          t.pstGroupFlag = true;
          t.clientBundle.gFields.complete.filter(
            (y) => y.ID.toUpperCase() === "PSTGROUP"
          )[0].List = [
            ...t.clientBundle.gTables._Groups
              .filter((y) => y.PlaybookGroup)
              .map((x) => x.ID),
            ...t.clientBundle.gFields.complete
              .filter((y) => y.ID.toUpperCase() === "PSTGROUP")[0]
              .List.split("|")
              .filter((y) => Boolean(y)),
          ].join("|");
        }
      },
    },
    vmAuth: {
      deep: true,
      handler: function () {
        let t = this;
        if (t.clientBundle.logonData) {
          // if (!t.clientBundle.gTables) t.pbGtables();
          // if (!t.clientBundle.gFields) t.pbGfields();
          if (t.keepAlivePing) clearInterval(t.keepAlivePing);
          t.logonButtonDirty = false;
          t.showConnectFields = false;
          t.keepAlivePing = setInterval(function () {
            t.pbPing(function (x) {
              t.processTimedPing(x);
            });
          }, 30000);
        }
        if (t.clientBundle.logonData && t.clientBundle.logonData.HomeDatabase) {
          t.pbList();
        }
      },
    },
  },
  methods: {
    processTimedPing: function (jsonTimeString) {
      const t = this;
      let d = JSON.parse(jsonTimeString);
      //test response is 404/401/false
      if (d === 401 || d === 404 || !d) {
        //ping rejected, increment counter
        t.retryCounters.timedPing = t.retryCounters.timedPing + 1;
        if (t.retryCounters.timedPing > 3) {
          //too many bad pings logout
          t.pbLogout();
          //show connect panel
          t.showConnectFields = true;
          //show disconnect alert
          t.showDisconnectAlert = true;
        }
      } else {
        // set last ping time
        t.lastPingTime = d;
        //clear counter
        t.retryCounters.timedPing = 0;
      }
    },
    guessServerType: function () {
      const t = this;

      let params = new URLSearchParams(
        `${window.location.search.replace("?", "")}`
      );

      let _type;
      try {
        _type = `${
          params.get("report") || localStorage.getItem("report") || ""
        }`.toLowerCase();
      } catch (_) {
        _type = "";
      }
      if (_type === "both") {
        return "both";
      } else if (_type === "enps") {
        return "ENPS";
      } else if (_type === "playbook") {
        return "Playbook";
      } else if (
        t.clientBundle.gTables._Groups.filter((y) => y.PSTGroup).length > 0
      ) {
        if (t.clientBundle.gTables._Servers.length > 2) {
          return "both";
        } else {
          return "Playbook";
        }
      } else if (
        !t.clientBundle.gTables._Groups.filter((y) => y.PSTGroup).length
      ) {
        return "ENPS";
      }
    },
    updateParent: function (updateType) {
      const t = this;
      if (updateType === "auth") {
        this.$emit("authSuccess", t.clientBundle);
      } else if (updateType === "search") {
        this.$emit("searchResults", t.searchResults);
      } else if (updateType === "savedSearches") {
        this.$emit("savedSearches", t.clientBundle.savedSearches);
      }
    },
    pbGetRundown: function (c) {
      const t = this;
      const s = t.clientBundle.savedSearches;
      playbookControl.getEnpsRundown(
        t.vmAuthComputed,
        s.database,
        s.path,
        s.guid,
        function (rec) {
          if (rec === "401" && t.retryCounters.rundown < 5) {
            t.retryCounters.rundown++;
            t.pbGetRundown(c);
          } else {
            c(rec);
            t.updateParent("savedSearches");
          }
        }
      );
    },
    pbList: function () {
      const t = this;
      playbookControl.pbListContent(
        t.vmAuthComputed,
        {
          StartTime: "2001-01-01T05:00:00.000Z",
          path: "U_" + t.vmAuth.userId.toUpperCase() + "\\REPORTING",
          database: t.clientBundle.logonData.HomeDatabase,
          type: 2,
        },
        function (list) {
          if (list === "401" && t.retryCounters.list < 5) {
            t.retryCounters.list++;
            t.pbList();
          } else if (list && list.Records && list.Records.length < 1) {
            //no saved search object, create new one
            playbookControl.putEnpsRundown(
              t.vmAuthComputed,
              {
                database: t.clientBundle.logonData.HomeDatabase,
                path: `U_${t.vmAuth.userId.toUpperCase()}\\REPORTING`,
                zFields: {
                  Title: "saved_reports",
                  ReportingSettings: JSON.stringify({}),
                },
              },
              function (c) {
                if (!c) return;
                let v = {};
                c.map((x) => {
                  v[x.FieldName] = x.FieldValue;
                });
                t.clientBundle.savedSearches = {
                  guid: v.Guid,
                  title: v.Title,
                  path: v.Path,
                  database: v.Database,
                  type: v.Type,
                  list: JSON.parse(v.ReportingSettings),
                };
              }
            );
          } else if (list && list.Records && list.Records.length > 0) {
            let r = list.Records[0].ListData;
            //get record 0
            // set initial savedSearch rundown location data
            t.clientBundle.savedSearches = {
              guid: r.Guid,
              title: r.Title,
              path: r.Path,
              database: r.ENPSDatabase,
              type: r.Type,
            };
            t.pbGetRundown(function (rec) {
              if (Array.isArray(rec) && rec.length === 0) rec = {};
              try {
                t.clientBundle.savedSearches.list = JSON.parse(
                  rec.ObjectProperties.filter(
                    (x) => x.FieldName === "ReportingSettings"
                  ).map((x) => x.FieldValue)
                );
              } catch {
                t.clientBundle.savedSearches.list = {};
              }
              t.updateParent("savedSearches");

              // };
            });
          } else if (!list) {
            console.log(
              "failed to get saved searches, could not connect to server."
            );
          }
        }
      );
    },
    pbSaveContent: function (callback) {
      const t = this;
      playbookControl.patchBasicContent(
        t.vmAuthComputed,
        {
          database: t.clientBundle.savedSearches.database,
          type: t.clientBundle.savedSearches.type,
          guid: t.clientBundle.savedSearches.guid,
          path: `U_${t.vmAuth.userId.toUpperCase()}\\REPORTING`,
          zFields: {
            type: 2,
            ModTime: new Date().toISOString(),
            ReportingSettings: JSON.stringify(
              t.clientBundle.savedSearches.list
            ),
          },
        },
        function () {
          t.pbList();
          if (typeof callback === "function") callback();
        }
      );
    },
    pbGfields: function () {
      const t = this;
      playbookControl.pbGfields(t.vmAuthComputed, function (fields) {
        if (fields) {
          t.clientBundle.gFields = fields;
        } else if (!fields && t.retryCounters.gFields < 5) {
          t.retryCounters.gFields++;
          t.pbGfields();
        }
      });
    },
    pbGtables: function () {
      const t = this;
      playbookControl.pbGtables(t.vmAuthComputed, function (tables) {
        if (tables) {
          tables._Groups.sort(t.compareValues("Server", "asc"));
          t.clientBundle.gTables = tables;
        } else if (!tables && t.retryCounters.gTables < 5) {
          t.retryCounters.gTables++;
          t.pbGtables();
        }
      });
    },
    pbTestServer: async function (callback) {
      const t = this;
      playbookControl.pbPing(
        { playbookUri: t.playbookUriFormatted, xToken: "" },
        function (response) {
          if (response === "401") {
            t.uriTest.server = true;
            t.urlInputHandler();
            t.pbGetPlaybookServices(function () {
              t.pbGetSSOSettings();
              t.pbGetSSOConfig();
              callback(true);
            });
          } else if (!response || response === "404") {
            t.uriTest.server = false;
            callback(false);
          }
        }
      );
    },
    pbPing: function (callback) {
      const t = this;
      playbookControl.pbPing(t.vmAuthComputed, function (response) {
        if (!response && t.retryCounters.ping < 5) {
          t.retryCounters.ping++;
          t.pbPing(callback);
        } else {
          if (typeof callback === "function") {
            callback(response);
          }
        }
      });
    },
    pbLogout: function () {
      const t = this;
      clearInterval(t.keepAlivePing);
      playbookControl.pbLogout(t.vmAuthComputed, function (res) {
        if (res) t.clientBundle.logonData = false;
        t.searchResults = [];
        t.updateParent("search");
      });
      t.logonButtonDirty = false;
      t.clientBundle.logonData = false;
    },
    resetApiInfoTests: function () {
      const t = this;
      Object.keys(t.apiInfoTest).forEach((x) => (t.apiInfoTest[x] = null));
      t.showConnectError = false;
    },
    pbLogon: function () {
      const t = this;
      t.logonButtonDirty = true;
      t.showConnectError = false;
      t.resetApiInfoTests();
      playbookControl.pbLogon(t.vmAuthComputed, function (response) {
        t.logonButtonDirty = false;
        t.processLogonResponse(response);
      });
    },
    processRawSearchResults: function (searchResults, searchRequest, callback) {
      const t = this;
      let ret = searchResults.map((x) => {
        //all the fixups
        let r = {};
        //swap ~C#~ and nonbreaking spaces
        x.forEach((y) => {
          r[y.FieldName] =
            typeof y.FieldValue === "string"
              ? y.FieldValue.toString()
                  .replace(/\u00a0/g, " ")
                  .replaceAll("~C10~", "\n")
                  .replaceAll("~C13~", "\r")
                  .replaceAll("~C9~", "  ")
              : y.FieldValue;
        });
        //render html from enpsml2
        if (r.text) r.text = clearHTMLTags(r.text);

        //fixup cost validated fields
        const CostFields = t.clientBundle.gFields.complete
          .filter((y) => y.Validation === "Cost")
          .map((x) => x.ID);
        CostFields.forEach((cf) => {
          const CostFieldListItems = t.clientBundle.gFields.complete
            .filter((y) => y.ID === cf)[0]
            .List.split("|");
          if (r[cf]) {
            let costValueArr = r[cf].split("\r");
            for (let i = 0; i < costValueArr.length; i++) {
              let costItemValue = costValueArr[i];
              let splitValue = CostFieldListItems.filter(
                (y) => costItemValue.indexOf(y) === 0
              )[0];
              // r[cf + "_" + splitValue] = '$'+costItemValue.split(splitValue)[1];
              r[cf + "_" + splitValue] = localCurrencyFormatter(
                costItemValue.split(splitValue)[1]
              );
              // searchRequest.fieldsToReturn.push(cf + "_" + splitValue);
            }
          }
        });

        if (
          ["3", "8"].includes(`${r.type}`) &&
          searchRequest.fieldsToReturn.some((r) =>
            ["Segment", "Slug"].includes(r)
          )
        ) {
          //object needs either slug or segment
          //get content separator
          let separator =
            t.clientBundle.gTables._ConfigSettings.TitleSeperator || "-";
          if (searchRequest.fieldsToReturn.includes("Segment")) {
            r.Segment =
              r.Title.indexOf(separator) > -1
                ? r.Title.substring(r.Title.indexOf(separator) + 1)
                : "";
          }
          if (searchRequest.fieldsToReturn.includes("Slug")) {
            r.Slug = r.Title.split(separator)[0];
          }
        }
        //replace Type numbers with captions
        if (r.type) r.type = ENPSObjectDictionary[r.type];

        //array of time/date validation fields
        const dateTypeArr = t.clientBundle.gFields.complete
          .filter(
            (yy) =>
              searchRequest.fieldsToReturn
                .map((f) => f.toLowerCase())
                .includes(yy.ID.toLowerCase()) &&
              ["Time", "Date"].includes(yy.Validation)
          )
          .map((tt) => tt.ID.toLowerCase());

        // replace time/date fields with LocaleString()
        Object.keys(r).forEach((key) => {
          let lck = key.toLowerCase();
          if (dateTypeArr.includes(lck)) {
            r[key] = new Date(r[key]).toLocaleString();
          }
        });

        //fixup Est Duration
        if (searchRequest.fieldsToReturn.includes("Estimated")) {
          r.Estimated = timeStr(r.Estimated);
        }

        //fixup actual time
        if (searchRequest.fieldsToReturn.includes("Actual")) {
          //case 1 actual time exists
          if (r.Actual != null) {
            r.Actual = timeStr(r.Actual);
          } else if (r.TextTime || r.MediaTime) {
            //case 2 texttime or media time exist
            r.Actual = timeStr(
              (r.TextTime ? r.TextTime : 0) + (r.MediaTime ? r.MediaTime : 0)
            );
          } else if (!r.MediaTime && !r.TextTime && !r.Actual) {
            //case 3 no text or media or actual set 0s
            r.Actual = timeStr();
          }
        }
        // add parent guid to Parent column
        if (searchRequest.fieldsToReturn.includes("parentCollection")) {
          r.parentCollection = r.virtualPath.includes("\\R_")
            ? r.virtualPath.split("R_")[1].substring(0, 36)
            : "";
        }
        // set parent database
        if (searchRequest.fieldsToReturn.includes("parentDatabase")) {
          r.parentDatabase = r.virtualPath.split("\\")[1];
        }

        // set parent folder name
        if (searchRequest.fieldsToReturn.includes("parentFolder")) {
          let i = r.virtualPath.includes("S_ARCHIVE") ? 2 : 1;
          r.parentFolder = r.virtualPath.split("_")[i].split("\\")[0];
        }

        return r;
      });

      if (searchRequest.fieldsToReturn.includes("parentCollection")) {
        t.pbSearchFields(
          [
            {
              ...searchRequest,
              queryTerms: "",
              NOMContentTypes: { All: true },
              zFields: [
                {
                  FieldName: "guid__list__",
                  FieldValue: ret
                    .filter((y) => y.parentCollection.length > 0)
                    .map((x) => x.parentCollection)
                    .join(";"),
                },
              ],
              FieldsToReturn: ["Title", "guid", "StartTime", "type"],
            },
          ],
          function (parentResults) {
            let lookupTitle = {};

            parentResults.SearchResults.forEach((x) => {
              lookupTitle[
                x.filter((y) => y.FieldName === "guid")[0].FieldValue
              ] = `${
                x.filter((y) => y.FieldName === "Title")[0].FieldValue
              } [${new Date(
                x.filter((y) => y.FieldName === "modTime")[0].FieldValue
                // ).toLocaleString()}]`;
              ).toLocaleDateString()}]`;
            });

            ret.forEach((f) => {
              if (f.parentCollection.length > 0) {
                f.parentCollection = lookupTitle[f.parentCollection];
              }
            });
            callback(ret);

            t.updateParent("search");
          },
          false
        );
      } else callback(ret);
    },
    pbSearchFields: function (s, callback, process = true) {
      const t = this;
      //todo add test functionality with the process variable ===false signalling a maxrecord 1 search just to see if there's anything there
      const searchArray = s || t.searchFieldsPayload;
      t.searchResults = [];
      for (let i = 0; i < searchArray.length; i++) {
        const search = searchArray[i];
        playbookControl.pbSearchFields(
          t.vmAuthComputed,
          search,
          function (response) {
            if (response === "401" && t.retryCounters.search < 5) {
              t.retryCounters.search++;
              console.log("500 rerack count: " + t.retryCounters.search);
              setTimeout(function () {
                t.pbSearchFields(s, callback);
              }, 500);
            } else if (response && process) {
              t.processRawSearchResults(
                response.SearchResults,
                search,
                function (fixedArr) {
                  t.searchResults.push(...fixedArr);
                  t.updateParent("search");
                }
              );
              callback(t.searchResults);
            } else if (response && !process) {
              // process=false is alternate result processing for other searches like a test or getting parent info
              callback(response);
            } else if (!response) {
              callback([]);
            }
          }
        );
        t.updateParent("search");
      }
    },
    getLocal: function (callback) {
      const t = this;
      let authCheck = JSON.parse(window.localStorage.getItem("auth"));
      if (authCheck) {
        authCheck.password =
          this.versionType === "development" ? authCheck.password : "";
        for (let k in authCheck) {
          t.vmAuth[k] = authCheck[k];
        }
      }
      if (typeof callback === "function") {
        callback(t.vmAuth);
      }
    },
    saveLocal: function (callback) {
      const t = this;
      const saveAuth =
        t.versionType === "development"
          ? t.vmAuth
          : {
              userId: t.vmAuth.userId,
              playbookUri: t.vmAuth.playbookUri,
              xToken: t.vmAuth.xToken,
            };
      window.localStorage.setItem("auth", JSON.stringify(saveAuth));
      if (typeof callback === "function") {
        callback();
      }
    },
    urlInputHandler: function () {
      const t = this;
      if (t.playbookUriValid && t.uriTest.server) {
        t.vmAuth.playbookUri = t.playbookUriFormatted
          .toLowerCase()
          .replace("/nomwebservices3api/api", "");
        localStorage.setItem("playbookUri", t.vmAuth.playbookUri);
      }
    },
    enterKeyHandler: function () {
      const t = this;
      t.logonButtonDirty = true;
      t.pbTestServer(function (res) {
        t.logonButtonDirty = false;
        if (
          res &&
          t.uriTest.server &&
          t.playbookUriValid &&
          t.vmAuth.userId.length > 0 &&
          t.vmAuth.password.length > 0
        ) {
          t.pbLogon();
        }
      });
    },
    compareValues: function (key, order = "asc") {
      return function (a, b) {
        if (
          !!Object.getOwnPropertyDescriptor(a, key) ||
          !!Object.getOwnPropertyDescriptor(b, key)
        ) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    pbGetSSOSettings: function () {
      const t = this;
      //this gets called first returns array. If array.length>0pbGetSSOConfig & foreach object in array render button.  if empty array do nothing
      playbookControl.pbGetSSOSettings(t.vmAuthComputed, function (settings) {
        if (settings) {
          t.ssoSettings.settings = settings.map((x) => {
            x.ID = x.ID.replace(" ", "");
            return x;
          });
        } else {
          t.ssoSettings.settings = [];
        }
      });
    },
    pbGetSSOConfig: function () {
      const t = this;
      //this gets called first returns array. If array.length>0pbGetSSOConfig & foreach object in array render button.  if empty array do nothing
      playbookControl.pbGetSSOConfigSettings(
        t.vmAuthComputed,
        function (config) {
          if (config) {
            t.ssoSettings.config = config;
          } else {
            t.ssoSettings.settings = [];
          }
        }
      );
    },
    onSSOClick: function (sso) {
      const t = this;
      localStorage.setItem("ssoProvider", sso.ID);
      window.location.href =
        t.ssoSettings.config.AuthAppUrl +
        "/#/?providerName=" +
        sso.ID.replace(" ", "") +
        "&redirectUri=" +
        t.SSORedirectUrl;
    },
    processLogonResponse: function (response, sso = false) {
      const t = this;
      if (response && response.SessionID) {
        if (sso) t.vmAuth.userId = response.UserID;
        t.clientBundle.logonData = response;
        t.vmAuth.xToken = response.SessionID;
        t.apiInfoTest.user = true;
        t.apiInfoTest.password = true;
        t.saveLocal();
        // t.pbList();
        t.pbGtables();
        t.pbGfields();
        if (sso) {
          let urlNew =
            window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname;
          window.history.pushState({ path: urlNew }, "", urlNew);
        }
      } else if (response === "403") {
        //incorrect user id
        t.apiInfoTest.user = false;
        t.apiInfoTest.password = null;
        t.showConnectError = true;
      } else if (response === "401") {
        //incorrect password
        t.apiInfoTest.user = true;
        t.apiInfoTest.password = false;
        t.showConnectError = true;
      } else if (response === "404") {
        //incorrect url
        t.apiInfoTest.serverResponse = false;
        t.apiInfoTest.serverUrl = t.playbookUriValid;
        t.showConnectError = true;
      } else if (response == null) {
        //incorrect url
        console.log("bad connection");
        t.showConnectError = true;
        t.apiInfoTest.serverResponse = false;
        t.apiInfoTest.serverUrl = t.playbookUriValid;
      }
    },
    pbSSOLogon: function () {
      const t = this;
      playbookControl.pbSSOLogon(t.vmAuthComputed, (response) => {
        t.logonButtonDirty = false;
        t.processLogonResponse(response, true);
      });
    },
    pbGetPlaybookServices: function (callback) {
      let t = this;
      t.vmAuth.playbookUriServiceUrls = [];
      playbookControl.scrapePlaybookServiceAddresses(
        { playbookUri: t.playbookUriFormatted },
        (response) => {
          // if (response && response.length > 0) {
          let loopEnd = !response ? 1 : response.length;
          for (let index = 0; index < loopEnd; index++) {
            const svcUrl =
              response && loopEnd > 0
                ? response[index]
                : t.playbookUriFormatted;
            playbookControl.pbPing(
              { playbookUri: svcUrl, xToken: "" },
              function (pingResponse) {
                if (pingResponse === "401") {
                  // t.vmAuth.playbookUri = svcUrl;
                  t.vmAuth.playbookUriServiceUrls.push(svcUrl);
                  localStorage.setItem(
                    "playbookUriServiceUrls" + index,
                    svcUrl
                  );
                  if (index + 1 === loopEnd) callback();
                }
              }
            );
          }
          // }
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.validUrl {
  border-color: green;
  border-width: thin;
}

.invalidAuth {
  border-color: red;
  border-width: thin;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
